import { useId } from 'react'
import {Props_Logos} from "./Logos.props";

const SnippetLogos = (props: Props_Logos) => {

    const snippetId = useId();
   
    return (
            <div className="logos-container">
                <div className="logos-container__inner">
                    {props.repeatable_logos?.map((item, index) => (
                        <a 
                            key={`snippet-logo-${snippetId}-${index}`}
                            className="logo-item" 
                            href={item.linkHref?.value || '#'} 
                            {...(item.linkAriaLabel?.value && { 'aria-label': item.linkAriaLabel.value })}
                        >
                            {item.logo?.value && <img src={item.logo.value} alt={item.altText?.value || 'Logo'} />}
                        </a>
                    ))}
                </div>
            </div>
        );
}


export default SnippetLogos;